export default __webpack_public_path__ + "static/media/11.64223e4e.jpg";